import { HttpEvent, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { map, catchError, throwError, from, mergeMap } from 'rxjs';
import { ShowMessageService } from '../services';

/**
 * `responseType: 'blob'` so'rovlarida xato tanasi ham Blob bo'lib keladi
 * (masalan `{ errorMessage }` JSON) — matnini o'qib, xabarni ajratib olamiz.
 */
function extractBlobErrorMessage(text: string): string | undefined {
  try {
    const body = JSON.parse(text);
    return body?.errorMessage || body?.error || body?.Error || body?.message || undefined;
  } catch {
    return undefined;
  }
}

export const httpErrorInterceptor = (req: any, next: any) => {
  const $msgService = inject(ShowMessageService);
  return next(req).pipe(
    catchError((error) => {
      if (error.status == 403) {
        $msgService.errorMsg('you_are_not_authorized_to_access_this_resource');
        throw new Error('you_are_not_authorized_to_access_this_resource');
      }
      if (error?.error instanceof Blob) {
        return from(error.error.text() as Promise<string>).pipe(
          mergeMap((text) => {
            $msgService.errorMsg(extractBlobErrorMessage(text));
            return throwError(() => new Error('something_went_wront'));
          }),
        );
      }
      $msgService.errorMsg(error?.error?.Error ?? error?.error?.errorMessage);
      throw new Error('something_went_wront');
    }),
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        const body = event.body;
        const skipBodyErrorToast = req.headers.has('X-Skip-Body-Error-Toast');
        if (body && body.error && !skipBodyErrorToast) {
          $msgService.errorMsg(body.error);
          throw new Error(body.error);
        }
      }
      return event;
    }),
  );
};
